import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import CustomButton from '../../components/customButton';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { userSelector } from '../../store/userSlice';
import { useNavigate } from 'react-router-dom';
import Soumission from './components/soumission/soumission';
import Inscription from './components/inscription/inscription';
import getEnvironement from '../../environnement';
import { setLang } from '../../store/langSlice';
import InscriptionAtelier from './components/ateliers/inscriptionAtelier';

export default function Event() {
  const [activeTab, setActiveTab] = useState(1);

  const [badgeNotification, setBadgeNotification] = useState(0);
  const [reservationsNotification, setReservationsNotification] = useState([]);
  const [messagesNotification, setMessagesNotification] = useState([]);

  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const tabs = [
    {id: 1, tab: 'Soumission'},
    {id: 2, tab: 'Inscription'},
    {id: 3, tab: 'Ateliers'},
  ]

  function getContent() {
    switch (activeTab) {
      case 1: return <Soumission />;
      case 2 : return <Inscription />;
      case 3 : return <InscriptionAtelier />;
      default: return <div />;
    }
  }

  async function getNotificationData() {
    const url = `${getEnvironement().API_URL}/notificationData`;
    await axios.post(url)
      .then((res) => {
        setReservationsNotification(res.data.reservations);
        setMessagesNotification(res.data.messages);
      })
      .then(() => setBadgeNotification(reservationsNotification.length + messagesNotification.length))
      .catch(() => {});
  }

  useEffect(() => {
    dispatch(setLang('fr'));
  }, [dispatch]);

  useEffect(() => {
    setBadgeNotification(reservationsNotification.length + messagesNotification.length);
  }, [reservationsNotification, messagesNotification]);

  useEffect(() => {
    getNotificationData();
  }, []);

  useEffect(() => {
    if (user === null) {
      navigate('/admin');
    }
  }, [navigate, user]);

  return (
    <div className='h-screen flex flex-col'>
      <ToastContainer />
      <div className='h-38'>
        <Header
          activeItem='Event'
          reservations={reservationsNotification}
          messages={messagesNotification}
          badgeNotification={badgeNotification}
        />
      </div>
      <div className='w-full 3xl:flex 3xl:justify-center flex-grow'>
        <div className='3xl:w-[1200px] px-10 py-5 3xl:py-5 3xl:px-0 h-full flex flex-col justify-center'>
          <div className='flex flex-col xl:flex-row xl:justify-between xl:gap-5 w-full'>
            {tabs.map((item) => {
              return (
                <CustomButton
                  value={item.tab}
                  outlined={activeTab !== item.id}
                  admin
                  handelClick={() => setActiveTab(item.id)}
                />
              );
            })}

          </div>
          {getContent()}
        </div>
      </div>
    </div>
  );
}
